import Filter from './Filter'
import ButtonBarFilter from './ButtonBarFilter'
import SelectBoxFilter from './SelectBoxFilter'
import TextFieldFilter from './TextFieldFilter'

const $ = jQuery

class Filters {
    filterOperator: 'AND' | 'OR' = 'AND'
    filters: Filter[] = []

    resetButton: JQuery | null = null

    onFiltersChange: () => void

    constructor(filtersView: JQuery) {
        filtersView.children().each((i, it) => {
            const filterView = $(it)
            let filter: Filter = null
            if (filterView.hasClass('filter-buttonbar')) {
                filter = new ButtonBarFilter(filterView)
            }
            if (filterView.hasClass('filter-selectbox')) {
                filter = new SelectBoxFilter(filterView)
            }
            if (filterView.hasClass('filter-textfield')) {
                filter = new TextFieldFilter(filterView)
            }
            if (filterView.hasClass('filter-reset')) {
                this.resetButton = filterView
                this.resetButton.find('button').on('click', () => {
                    this.resetFilters()
                })
            }
            if (filter) {
                filter.onFilterChange = () => this.onFiltersChange()
                this.filters.push(filter)
            }
        })
    }

    private resetFilters() {
        for (const filter of this.filters) {
            filter.reset()
        }
        this.onFiltersChange()
    }

    async matches(item: PostItem): Promise<boolean> {
        const operator = this.filterOperator
        for (const i in this.filters) {
            const match = await this.filters[i].matches(
                item,
                item.categories[i],
            )
            if (operator === 'OR' && match) return true
            if (operator === 'AND' && !match) return false
        }
        return operator === 'AND'
    }
}

export default Filters
